import React from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../behavioral";
import { ICategoryType, IMediaResponseDto } from "../../libs";
import { vodService } from "../../services";

import * as Styled from "./VodUploads.styled";
import { VodContent } from "../../components/vod-components";

export const VodUploads = () => {
    const navigate = useNavigate();
    const auth = useAuth();

    const [clientId, setClientId] = React.useState("");
    const [showLoader, setShowLoader] = React.useState(true);
    const [mediaItems, setMediaItems] = React.useState<IMediaResponseDto[]>([]);
    const [categories, setCategories] = React.useState<ICategoryType[]>([]);
    const [
        shouldListenToMediaConvertStatus,
        setShouldListenToMediaConvertStatus,
    ] = React.useState(false);
    // eslint-disable-next-line
    const [progressItems, setProgressItems] = React.useState<{
        [key in string]: { percentage: number; currentPhase: string };
    }>({});

    const getUserUploads = React.useCallback(async () => {
        console.log("getting user uploads");
        const results = await vodService.getAllMediaItems();
        const categories_l = await vodService.getCategories();
        setCategories(categories_l);
        if (results) {
            setMediaItems(results);
            setShowLoader(false);
            if (
                results.filter((item: IMediaResponseDto) => !item.processed)
                    .length > 0
            ) {
                setShouldListenToMediaConvertStatus(true);
            } else {
                setShouldListenToMediaConvertStatus(false);
            }
        }
    }, []);

    const listenForMediaConvertStatus = React.useCallback(() => {
        const websocket = new WebSocket(
            `${process.env.REACT_APP_VOD_STATUS_WEBSOCKET_URL}?clientId=${auth.user?.username}`,
        );

        websocket.onopen = (event) => {
            console.log("Connected to Socket");
            websocket.send(
                JSON.stringify({
                    action: "getConnectionId",
                    clientId: auth.user.username,
                }),
            );
        };

        websocket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log(data);
            if (data.type === "initial") {
                localStorage.setItem("connectionId", data.connectionId);
            } else if (data.type === "status") {
                // Set media convert status here
                if (data.mediaInfo) {
                    // setProgressItems({
                    //   ...progressItems,
                    //   [data.mediaInfo.id]: {
                    //     currentPhase: data.mediaInfo.progress.currentPhase,
                    //     percentage: data.mediaInfo.progress.percentage,
                    //   },
                    // });
                }
            } else {
                if (data.type === "complete") {
                    // set media convert ouputs here
                    // let updatedProgressItems = {};
                    // Object.keys(progressItems).forEach((key) => {
                    //   if (key !== data.mediaInfo.id) {
                    //     updatedProgressItems = {
                    //       [key]: progressItems,
                    //     };
                    //   }
                    // });

                    // setProgressItems({ ...updatedProgressItems });
                    console.log("Fetched uploads again");
                    getUserUploads();
                }
            }
        };

        websocket.onclose = (event) => {
            localStorage.removeItem("connectionId");
            console.log("Closed", event);
        };

        websocket.onerror = (event) => {
            console.log(
                "There is an error while connecting to websocket",
                event,
            );
        };
    }, [auth.user?.username, getUserUploads]);

    React.useEffect(() => {
        if (auth.isAuthenticated) {
            setClientId(auth.user.username);
            getUserUploads();
        } else {
            navigate("/login", { replace: true });
        }
    }, [getUserUploads, navigate, auth.isAuthenticated, auth.user]);

    const handleUploadsUpdate = React.useCallback(() => {
        getUserUploads();
    }, [getUserUploads]);

    React.useEffect(() => {
        console.log("inside useEffect");
        if (shouldListenToMediaConvertStatus) {
            console.log("inside useEffect if condition");
            listenForMediaConvertStatus();
        }
    }, [listenForMediaConvertStatus, shouldListenToMediaConvertStatus]);

    return (
        <>
            {showLoader ? (
                <Styled.SpinnerWrapper>
                    <Spinner animation="border">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p>Fetching the uploads...</p>
                </Styled.SpinnerWrapper>
            ) : (
                <VodContent
                    clientId={clientId}
                    mediaItems={mediaItems}
                    categories={categories}
                    onUpdateUploads={handleUploadsUpdate}
                    progressItems={progressItems}
                />
            )}
        </>
    );
};
